import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const DIStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnDiariePlan,
  rutinInfos.rtnMottagare,
  rutinInfos.rtnHandlaggare,
  rutinInfos.rtnHandlingstyp,
  rutinInfos.rtnDIStandardText,
  rutinInfos.rtnDIStandardTextArkiv,
  rutinInfos.rtnDiariegrupp,
  rutinInfos.rtnUsersDI,
];

export default DIStyrvardeMeny;
